import React, { useRef, useEffect } from 'react';

export { TaskList };

function TaskList(props) {
    const { taskList, ...taskProps } = props;
    return (
        <ul className="task_list">
            {taskList.map(task => {
                return (
                    <Task key={task.id} taskId={task.id} name={task.name} state={task.state} isChecked={task.isChecked} {...taskProps} />
                );
            })}
        </ul>
    );
}

function Task(props) {
    const textInput = useRef(null),
        task = {
            edit:
                <input className='task-name_edit'
                    ref={textInput}
                    type="text"
                    value={props.name}
                    onChange={(ev) => props.handleChange({ ev: ev, type: 'taskNameInput', taskId: props.taskId })}
                    onBlur={() => props.handleBlur({ taskId: props.taskId })}
                />,
            view:
                <div className="task-name_view" onClick={() => props.handleClick({ taskId: props.taskId, type: 'edit' })}>
                    {props.name}
                </div>
        };

    useEffect(() => {
        if (props.state === 'editing' && textInput.current) {
            textInput.current.focus();
        }
    });

    return (
        <li className={props.isChecked ? 'task_list-task checked' : 'task_list-task'}>
            <label className='task-label'><input type="checkbox" checked={props.isChecked} onChange={() => props.handleChange({ taskId: props.taskId, type: 'taskCheck' })} /></label>
            <div className='task-data'>
                {props.state === 'editing' ? task.edit : task.view}
            </div>
            <div className="task-buttons">
                <button className='buttons-remove' onClick={() => props.handleClick({ taskId: props.taskId, type: 'remove' })}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                </button>
            </div>
        </li>
    );
}